export const customToken = {
  /**
   * 主体区域宽度
   */
  layoutContentWidth: 1182
}
